import {extend} from 'vee-validate';
import {i18n} from '@/locales';
import {required, required_if, min_value, confirmed, email, min, numeric, size, mimes} from 'vee-validate/dist/rules';
import postcode from "@/imports/validators/postcode";
import passwordValidator from '@/imports/validators/password';
import {isMobileNumber, isPhoneNumber} from '@/imports/validators/phoneNumber';
import {isValidIntlPhoneNumber} from '@/imports/validators/phoneNumber';
import wordCount from "@/imports/validators/wordCount";
import isValidVatNumber from "@/imports/validators/vatNumber";
import isEmailString from "@/imports/validators/emailString";

extend('required', {
  ...required,
  message: () => i18n.t('This field is required'),
});
extend('required_if', {
  ...required_if,
  message: () => i18n.t('This field is required'),
});
extend('postcode', {
  ...postcode,
  message: () => i18n.t('Please provide a valid UK postcode')
});
extend('min_value', {
  ...min_value,
  message: (field, opts) => i18n.t('validation_min_value', { minValue: i18n.n(opts.min, 'currency') }),
});
extend('confirmed', {
  ...confirmed,
  message: () => i18n.t('The confirm password field does not match the password')
});
extend('email', {
  ...email,
  message: () => i18n.t('Please enter a valid email address')
});
extend('min', {
  ...min,
  message: () => i18n.t('Please provide as much detail as possible')
});
extend('length', {
  validate(value, args) {
    return value.length <= Number(args.length);
  },
  message: (_, opts) => i18n.t('You have exceeded the {maxCharacters} character limit', { maxCharacters: opts.length }),
  params: ['length']
});
extend('wordCount', {
  ...wordCount,
  params: ['max'],
  message: () => i18n.t('You are over the maximum number of allowed characters')
});
extend('numeric', {
  ...numeric,
  message: () => i18n.t('The field must be a number')
});
extend('size', {
  ...size,
  message: (field, params) => i18n.t('validation_max_filesize', { maxSizeMB: params.size / 1024 }),
});
extend('mimes', {
  ...mimes,
  message: () => i18n.t('Please limit uploads to commonly used images or document file types.'),
})
extend('valid-password', passwordValidator);
extend('is-phone-number', isPhoneNumber);
extend('is-mobile', isMobileNumber);
extend('valid-phone-number', isValidIntlPhoneNumber);
extend('is-vat-number', isValidVatNumber);
extend('is-email-string', isEmailString);